import PageLayout from "@/components/PageLayout";
import Timeline from "@/components/Timeline";
import SEO from "@/components/SEO";

export default function HeritagePage() {
  return (
    <PageLayout>
      <SEO
        title="Our Story — 3 Generations of Lining Fabric Craftsmanship Since 1974 | Mutha Paras & Co."
        description="From Parasmal Mutha's first lining trade in 1974 to a modern 15 lakh+ meter stockhouse — the story of South India's most trusted lining fabric manufacturer."
        path="/heritage"
      />
      <Timeline />
    </PageLayout>
  );
}
